<template>
  <div class="stbox">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>手卫生数据上报</el-breadcrumb-item>
    </el-breadcrumb>
    <el-tabs style="margin-top: 15px" v-model="activeName">
      <el-tab-pane label="数据上报" name="first">
        <div class="text" style="margin-top: 20px">
          <label>请先从本地选择数据包，然后点击数据上传按钮提交。<label class="texthos">{{ loginUser.HospitalName }}(医疗机构代码:{{
            loginUser.HospitalNumber
          }})</label></label>
        </div>
        <div class="bottom">
          <el-image class="image" :src="src"></el-image>
          <div class="upload-position">
            <p class="alltext">上传：数据包文件要求ZIP格式</p>
            <el-upload accept=".zip" class="upload-demo" ref="upload" :action="uploadFileUrl + 'Upload/UploadSWSFile'"
              :before-upload="beforeUpload" :on-success="uploadSuccess" :on-exceed="handleExceed" :file-list="fileList"
              :auto-upload="false" :multiple="false" :limit="1">
              <el-button slot="trigger" type="primary">选择文件</el-button>
              <el-button style="margin-left: 10px" type="success" :loading="load" @click="submitUpload">数据上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传zip文件</div>
            </el-upload>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="数据浏览" name="third">
        <div style="display: flex" v-if="this.permission > 0">
          <el-select clearable filterable style="width: 20%" v-model="searchHospitalNumber" placeholder="请选择医院">
            <el-option v-for="item in hospitalData" :key="item.HospitalNumber" :label="item.HospitalName"
              :value="item.HospitalNumber">
            </el-option>
          </el-select>
        </div>
        <div>
          <el-tabs v-model="activeName2" @tab-click="handleClick">
            <el-tab-pane label="手卫生数据" name="sws-swsform">
              <el-form :inline="true" :model="swsform" class="demo-form-inline">
                <el-form-item label="录入时间">
                  <el-date-picker v-model="swsform.ksjssj" type="monthrange" align="right" unlink-panels
                    range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" value-format="yyyy-MM">
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="searchData()">搜索</el-button>
                  <el-button icon="el-icon-download" @click="exportData()">导出</el-button>
                </el-form-item>
              </el-form>
              <el-table class="sws" v-loading="loading" element-loading-text="加载中"
                element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
                :data="allData.slice((pageIndex - 1) * pageSize, pageIndex * pageSize)" stripe style="width: 100%">
                <el-table-column prop="Number" label="编号" width="150">
                </el-table-column>
                <el-table-column prop="deptName" label="科室" width="150">
                </el-table-column>
                <el-table-column label="观察级别" width="150">
                  <template slot-scope="scope">
                    <label v-if="scope.row.Kszc == '0'">院级观察</label>
                    <label v-if="scope.row.Kszc == '1'">科室自查</label>
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="Name" label="姓名" width="150"> </el-table-column> -->
                <el-table-column label="对象类别" width="150">
                  <template slot-scope="scope">
                    <label v-if="scope.row.OccupationCategory == '1'">医技</label>
                    <label v-if="scope.row.OccupationCategory == '3'">护工</label>
                    <label v-if="scope.row.OccupationCategory == '00'">本院医生</label>
                    <label v-if="scope.row.OccupationCategory == '01'">实习医生</label>
                    <label v-if="scope.row.OccupationCategory == '02'">规培医生</label>
                    <label v-if="scope.row.OccupationCategory == '03'">进修医生</label>
                    <label v-if="scope.row.OccupationCategory == '20'">本院护士</label>
                    <label v-if="scope.row.OccupationCategory == '21'">实习护士</label>
                    <label v-if="scope.row.OccupationCategory == '22'">规培护士</label>
                    <label v-if="scope.row.OccupationCategory == '23'">进修护士</label>
                    <label v-if="scope.row.OccupationCategory == '30'">保洁</label>
                    <label v-if="scope.row.OccupationCategory == '31'">陪伴</label>
                    <label v-if="scope.row.OccupationCategory == '33'">其他</label>
                  </template>
                </el-table-column>
                <el-table-column prop="" label="指征" width="200">
                  <template slot-scope="scope">
                    <label v-if="scope.row.Indications">{{
                      scope.row.Indications.replace("1", "接触病人前")
                        .replace("2", "无菌操作前")
                        .replace("3", "接触血液/体液后")
                        .replace("4", "接触病人后")
                        .replace("5", "接触环境后")
                        .replace("6", "接触患者周围环境后")
                        .replace("7", "清洗后")
                        .replace("8", "打包后")
                        .replace("9", "清洗前")
                    }}</label>
                    <label v-else></label>
                  </template>
                </el-table-column>
                <el-table-column label="措施" width="150">
                  <template slot-scope="scope">
                    <label v-if="scope.row.Measures == '0'">洗手+手消</label>
                    <label v-if="scope.row.Measures == '1'">洗手</label>
                    <label v-if="scope.row.Measures == '2'">未采取</label>
                    <label v-if="scope.row.Measures == '3'">戴手套</label>
                    <label v-if="scope.row.Measures == '4'">手消毒剂揉搓手</label>
                  </template>
                </el-table-column>
                <el-table-column label="步骤" width="150">
                  <template slot-scope="scope">
                    <label v-if="scope.row.Step == '0'">不足6步</label>
                    <label v-if="scope.row.Step == '1'">6步</label>
                    <label v-if="scope.row.Step == '2'">7步</label>
                  </template>
                </el-table-column>
                <el-table-column prop="SSTime" label="手卫生时间" width="150">
                  <template slot-scope="scope">
                    <label v-if="scope.row.IsRight == '0'">＜15s</label>
                    <label v-if="scope.row.IsRight == '1'">≥15s</label>
                  </template>
                </el-table-column>
                <el-table-column label="干手措施" width="150">
                  <template slot-scope="scope">
                    <label v-if="scope.row.DryHand == '0'">纸巾</label>
                    <label v-if="scope.row.DryHand == '1'">毛巾</label>
                    <label v-if="scope.row.DryHand == '2'">风机</label>
                    <label v-if="scope.row.DryHand == '3'">无</label>
                  </template>
                </el-table-column>
                <el-table-column label="手卫生是否正确" width="150">
                  <template slot-scope="scope">
                    <label v-if="scope.row.IsRight == '0'">不正确</label>
                    <label v-if="scope.row.IsRight == '1'">正确</label>
                  </template>
                </el-table-column>
                <el-table-column label="状态" width="150">
                  <template slot-scope="scope">
                    <label v-if="scope.row.State == '0'">未确认</label>
                    <label v-if="scope.row.State == '1'">已确认</label>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="是否手卫生知识提问" width="150">
                  <template slot-scope="scope">
                    <label v-if="scope.row.Knowledge == '0'">否</label>
                    <label v-if="scope.row.Knowledge == '1'">是</label>
                  </template>
                </el-table-column> -->
                <el-table-column prop="BeginTime" label="开始时间" width="180">
                </el-table-column>
                <el-table-column prop="EndTime" label="结束时间" width="180">
                </el-table-column>
                <el-table-column prop="RecordTime" label="提交时间" width="180">
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <div class="block">
              <el-pagination :current-page="pageIndex" :page-size="pageSize" layout="prev, pager, next, jumper"
                :total="allData.length" @current-change="currentPage" />
            </div>
          </el-tabs>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script type="text/ecmascript-6">
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { getHospital } from "../../api/hospital";
import { unZip, readSWSFiles } from "../../api/upload";
import { gethandhygiene } from "../../api/search";
export default {
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      load: false,
      loading: true,
      uploadFileUrl: "",
      activeName: "first",
      activeName2: "sws-swsform",
      loginUser: {},
      src: "../static/zip.png",
      fileList: [],
      hospitalData: [],
      hospitalNumber: "",
      hospitalName: "",
      searchHospitalNumber: "",
      allData: [],
      year_Month: [],
      years: [],
      swsform: {
        kssj: "",
        jssj: "",
        yydm: "",
      },
      permission: 0,
    };
  },
  created() {
    this.loginUser = JSON.parse(localStorage.getItem("userdata"))[0];
    this.hospitalName = this.loginUser.HospitalName;
    this.hospitalNumber = this.loginUser.HospitalNumber;
    this.permission = this.loginUser.permission;
    this.uploadFileUrl = sessionStorage.getItem("baseURL");
  },
  mounted() {
    this.init();
    this.getHospitalData();
    this.searchData();
  },
  methods: {
    currentPage(page) {
      this.pageIndex = page;
    },
    handleClick() {
      this.pageIndex = 1;
      this.searchData();
    },
    beforeUpload(file) {
      const fileSuffix = file.name.substring(file.name.lastIndexOf(".") + 1);
      const whiteList = ["zip"];
      if (whiteList.indexOf(fileSuffix) === -1) {
        this.$message.warning("只能上传zip文件");
        return false;
      }
    },
    submitUpload() {
      if (!this.$refs.upload.uploadFiles.length) {
        this.$message.warning("请选择文件");
        this.load = false;
        return;
      }
      this.$refs.upload.submit();
      this.load = true;
    },
    uploadSuccess(response) {
      unZip({
        zipPath: response.zipPath,
        unZipPath: response.unZipPath,
      }).then((res) => {
        if (res.status === "ok") {
          readSWSFiles({
            unZipPath: response.unZipPath,
            hCode: this.hospitalNumber,
            hName: this.hospitalName,
          }).then((res) => {
            if (res.status === "ok") {
              this.$alert(res.msg, '提示', {
                confirmButtonText: '确定',
              });
              this.$message.success(res.msg);
              this.$refs.upload.clearFiles();
              this.load = false;
              this.getHospitalData();
            } else {
              this.$alert(res.msg, '提示', {
                confirmButtonText: '确定',
              });
              this.$refs.upload.clearFiles();
              this.load = false;
            }
          });
        } else {
          this.$alert(res.msg, '提示', {
            confirmButtonText: '确定',
          });
          this.$refs.upload.clearFiles();
          this.load = false;
        }
      });
    },
    handleExceed(files) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件`
      );
    },
    exportData() {
      let data = this.allData
      let fileName = '手卫生数据'
      let headers = {
        Number: '编号',
        deptName: '科室',
        Kszc: '观察级别',
        OccupationCategory: '对象类别',
        Indications: '指征',
        Measures: '措施',
        Step: '步骤',
        SSTime: '手卫生时间',
        DryHand: '干手措施',
        IsRight: '手卫生是否正确',
        State1: '状态',
        BeginTime: '开始时间',
        EndTime: '结束时间',
        RecordTime: '提交时间'
      }
      const headerKeys = Object.keys(headers)
      const headerValues = Object.values(headers)
      const worksheetData = [
        headerValues,
        ...data.map(row =>
          headerKeys.map(key => row[key] || '')
        )
      ]
      for (let i = 1; i < worksheetData.length; i++) {
        if (worksheetData[i][2] == '1') {
          worksheetData[i][2] = '科室自查'
        } else if (worksheetData[i][2] == '0') {
          worksheetData[i][2] = '院级观察'
        }
        if (worksheetData[i][3] == '00') {
          worksheetData[i][3] = '本院医生'
        } else if (worksheetData[i][3] == '01') {
          worksheetData[i][3] = '实习医生'
        } else if (worksheetData[i][3] == '02') {
          worksheetData[i][3] = '规培医生'
        } else if (worksheetData[i][3] == '03') {
          worksheetData[i][3] = '进修医生'
        } else if (worksheetData[i][3] == '20') {
          worksheetData[i][3] = '本院护士'
        } else if (worksheetData[i][3] == '21') {
          worksheetData[i][3] = '实习护士'
        } else if (worksheetData[i][3] == '22') {
          worksheetData[i][3] = '规培护士'
        } else if (worksheetData[i][3] == '23') {
          worksheetData[i][3] = '进修护士'
        } else if (worksheetData[i][3] == '1') {
          worksheetData[i][3] = '医技'
        } else if (worksheetData[i][3] == '3') {
          worksheetData[i][3] = '工人'
        } else if (worksheetData[i][3] == '30') {
          worksheetData[i][3] = '保洁'
        } else if (worksheetData[i][3] == '31') {
          worksheetData[i][3] = '陪伴'
        } else if (worksheetData[i][3] == '32') {
          worksheetData[i][3] = '月嫂'
        } else if (worksheetData[i][3] == '33') {
          worksheetData[i][3] = '其他'
        }
        let zz = ''
        if (worksheetData[i][4].includes('1')) {
          zz += '接触病人前,'
        } else if (worksheetData[i][4].includes('2')) {
          zz += '无菌操作前,'
        } else if (worksheetData[i][4].includes('3')) {
          zz += '接触血液/体液后,'
        } else if (worksheetData[i][4].includes('4')) {
          zz += '接触病人后,'
        } else if (worksheetData[i][4].includes('5')) {
          zz += '接触环境后,'
        } else if (worksheetData[i][4].includes('6')) {
          zz += '接触患者周围环境后,'
        }
        worksheetData[i][4] = zz.substring(0, zz.length - 1)
        if (worksheetData[i][5] == '0') {
          worksheetData[i][5] = '洗手+手消'
        } else if (worksheetData[i][5] == '1') {
          worksheetData[i][5] = '洗手'
        } else if (worksheetData[i][5] == '2') {
          worksheetData[i][5] = '未采取'
        } else if (worksheetData[i][5] == '3') {
          worksheetData[i][5] = '戴手套'
        } else if (worksheetData[i][5] == '4') {
          worksheetData[i][5] = '手消毒剂揉搓手'
        }
        if (worksheetData[i][6] == '0') {
          worksheetData[i][6] = '不足6步'
        } else if (worksheetData[i][6] == '1') {
          worksheetData[i][6] = '6步'
        } else if (worksheetData[i][6] == '2') {
          worksheetData[i][6] = '7步'
        }
        if (worksheetData[i][7] == '0') {
          worksheetData[i][7] = '<15秒'
        } else if (worksheetData[i][7] == '1') {
          worksheetData[i][7] = '≥15秒'
        }
        if (worksheetData[i][8] == '0') {
          worksheetData[i][8] = '纸巾'
        } else if (worksheetData[i][8] == '1') {
          worksheetData[i][8] = '毛巾'
        } else if (worksheetData[i][8] == '2') {
          worksheetData[i][8] = '风机'
        } else if (worksheetData[i][8] == '3') {
          worksheetData[i][8] = '无'
        }
        if (worksheetData[i][9] == '0') {
          worksheetData[i][9] = '不正确'
        } else if (worksheetData[i][9] == '1') {
          worksheetData[i][9] = '正确'
        }
        if (worksheetData[i][10] == '0') {
          worksheetData[i][10] = '未确认'
        } else if (worksheetData[i][10] == '1') {
          worksheetData[i][10] = '已确认'
        }
      }
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, fileName)
      XLSX.writeFile(workbook, fileName + `.xlsx`)
    },
    init() {
      let nowYear = new Date().getFullYear();
      for (let i = 0; i < 10; i++) {
        this.years.push(nowYear--);
      }
      this.years.reverse();
    },
    searchData() {
      this.loading = true
      if (this.swsform.ksjssj === undefined) {
        this.$set(this.swsform, "ksjssj", [
          this.getCurrentDateYYYYMM(),
          this.getCurrentDateYYYYMM(),
        ]);
      }
      this.swsform.kssj = this.swsform.ksjssj[0];
      this.swsform.jssj = this.swsform.ksjssj[1];
      this.swsform.jssj =
        this.swsform.jssj + "-" + this.getCountDays(this.swsform.jssj);
      this.swsform.yydm = this.hospitalNumber;
      if (this.searchHospitalNumber != "") {
        this.swsform.yydm = this.searchHospitalNumber;
      }
      gethandhygiene(this.swsform).then((res) => {
        this.loading = false;
        this.allData = res.data;
      });
    },
    //获取医院
    getHospitalData() {
      getHospital({ hospitalName: "" }).then((res) => {
        this.hospitalData = []
        for (let i = 0; i < res.data.length; i++) {
          if (this.permission == 1) {
            this.hospitalData = res.data;
          } else if (this.permission == 2) {
            if (res.data[i].Area.split(',')[1] == this.loginUser.Area.split(',')[1]) {
              this.hospitalData.push(res.data[i])
            }
          } else if (this.permission == 3) {
            if (res.data[i].Area.split(',')[2] == this.loginUser.Area.split(',')[2]) {
              this.hospitalData.push(res.data[i])
            }
          }
        }
      });
    },
    getCurrentDateYYYYMM() {
      const now = new Date();
      const year = now.getFullYear();
      let month = now.getMonth() + 1;
      month = month.toString().padStart(2, "0");
      return `${year}-${month}`;
    },
    getCountDays(curDate) {
      const d = new Date(curDate);
      const y = d.getFullYear();
      //获取本月的下一个月
      const m = d.getMonth() + 1;
      // 下一个月的第0天就是这个月的天数
      const days = new Date(y, m, 0).getDate();
      return days;
    },
  },
};
</script>
<style>
.stbox {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.header {
  margin-top: 15px;
}

.header .first {
  margin-top: 30px;
  font-size: 14px;
}

.red {
  color: red;
}

.orange {
  color: orange;
}

.green {
  color: green;
}

.content {
  width: 90%;
  margin: 50px 5%;
}

.bottom {
  margin: 100px 0 0 100px;
  display: flex;
}

.image {
  height: 200px;
}

.upload-demo {
  margin: 90px 0 0 0;
}

.alltext {
  font-size: 14px;
}

.text {
  font-size: 14px;
}

.texthos {
  color: black;
}

.btnClass {
  height: 40px;
}

.el-row {
  margin-bottom: 20px;
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background-color: #ffa8a8;
  color: red;
}

.bg-purple {
  background-color: #ffa8a8;
  color: red;
}

.bg-purple-light {
  background-color: #ffa8a8;
  color: red;
}

.grid-content {
  border-radius: 4px;
  height: 36px;
  line-height: 36px;
  text-align: center;
}

.row-bg {
  padding: 10px 0;
  background-color: #ffa8a8;
  color: red;
}

.green-bg {
  background-color: #67c23a;
  color: #ffffff;
}

.select {
  width: 20%;
}

/* background-color: #ffcc99;
    color: #ff6600; */
</style>



// WEBPACK FOOTER //
// src/views/charts/handhygiene.vue